import * as React from 'react';
import { db } from '../config/firebase';
import { MyAppBar } from "../components/Home/MyAppBar/myAppBar";
import { Alert, Container } from "@mui/material";
import { useContext, useState } from 'react';
import { LoadingCircle } from '../components/loading';
import { collection, getDocs, query, where, updateDoc } from 'firebase/firestore';
import { useQuery } from '@tanstack/react-query';
import { AuthContext } from '../contexts/authContext';
import { ProfileDetails } from '../components/User/Profile/profileDetails';
import Snackbar from '@mui/material/Snackbar';
import {MainFooter} from '../components/Footer/mainFooter';
import { Margin } from '@mui/icons-material';
import { UserAppBar } from '../components/User/userAppBar';

export const User = () => {
    const { user } = useContext(AuthContext);
    const [profileRef, setProfileRef] = useState();
    const [notificationOpen, setNotificationOpen] = useState({ state: false, sev: "success", msg: "N/A" });

    const { data: uData, isDataLoading, isDataError } = useQuery({
        queryKey: ["loadprofile"], queryFn: async () => {
            const q = query(collection(db, "user"), where("owner", "==", user.uid));
            const data = await getDocs(q)

            const filteredData = data.docs.map((doc) => ({
                ...doc.data(),
            }));

            setProfileRef(data.docs[0].ref);

            if (filteredData.length !== 1) {
                console.log("ERROR");
            }
            console.log(filteredData[0]);

            return filteredData[0];
        }
    });

    const saveProfile = async (userData) => {
        uData.name = userData.name;
        uData.bio = userData.bio;
        uData.picurl = userData.picurl;

        const q = query(collection(db, "user"), where("owner", "==", user.uid));
        const data = await getDocs(q)

        updateDoc(data.docs[0].ref, uData)
            .then(() => {
                setNotificationOpen({ state: true, sev: "success", msg: "Profile saved" });
            })
            .catch(error => {
                setNotificationOpen({ state: true, sev: "error", msg: "Profile saving failed!" })
            });
    }

    const handleCloseSb = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setNotificationOpen({ state: false, sev: notificationOpen.sev, msg: notificationOpen.msg });
    };


    if (isDataLoading) return (
        <>
            <MyAppBar></MyAppBar>
            <Container maxWidth="md">
                <LoadingCircle />
            </Container>
        </>
    )

    if (isDataError) return (
        <>
            <MyAppBar></MyAppBar>
            <Container maxWidth="md">
                <h1>Ou ... Can't load profile data :(</h1>
            </Container>
        </>
    )

    if (!isDataLoading && !isDataError && uData) return (
        <>
            <UserAppBar userData={uData} ></UserAppBar>
            <ProfileDetails userData={uData} email={user.email} uid={user.ui} saveProfile={saveProfile} />
            <Snackbar open={notificationOpen.state} autoHideDuration={3000} onClose={handleCloseSb}>
                <Alert onClose={handleCloseSb} severity={notificationOpen.sev} sx={{ width: '100%' }}>
                    {notificationOpen.msg}
                </Alert>
            </Snackbar>
        </>
    );
};